export const initialContentState = {
  categories: [],
  currentProducts:{
    loading:false,
    data:{}
  },
  productMetaData:[]
}


export const productReducer = (state = null, action) => {
  switch (action.type) {
    case "SET_CATEGORY":
      return {...state, categories: action?.data};
    case "SET_PRODUCTS":
      return {...state, currentProducts: {...state?.currentProducts ,data: action?.data}};
    case "SET_PRODUCTS_LOADING":
      return {...state, currentProducts: {...state?.currentProducts ,loading: action?.loading}};
    case "SET_PRODUCTS_META_DATA":
      return {...state, productMetaData: action?.data};
    default:
      return state;
  }
};
